/**
 * Referral API slice (referral program management).
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const referralApi = {
  // Get the user's referral code and link (generates on first call)
  getCode: async () => {
    const data = await fetchWithAuth('/json/referral/code', {
      method: 'GET',
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to get referral code', data.status || 400, data);
    }

    return {
      referralCode: data.referralCode,
      referralLink: data.referralLink,
      stats: data.stats || {},
    };
  },

  // Get referral stats and history
  getStats: async () => {
    const data = await fetchWithAuth('/json/referral/stats', {
      method: 'GET',
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to get referral stats', data.status || 400, data);
    }

    return {
      stats: data.stats || {},
      referrals: data.referrals || [],
    };
  },
};
